import React, { useCallback, useMemo } from "react";
import { SearchBar } from "@src/components/organisms/searchbar-component/searchbar-component";
import { useUserManagementPageSearchHook } from "@src/components/organisms/user-management-page-search/use-user-management-page-search-hook";
import {
  UserManagementListActiveViewType,
  UserManagementListActiveRoleRenderDataType,
  UserManagementListActiveRoleEnum,
} from "@src/types/user-management";
import { useI18N } from "@src/language/language-context";

interface UserManagementPageSearchBarPropsTypes {
  userManagementListActiveView: UserManagementListActiveViewType;
  userManagementListActiveRoleData: UserManagementListActiveRoleRenderDataType;
  onRenderDataChange: (
    userManagementListActiveRoleData: UserManagementListActiveRoleRenderDataType,
  ) => void;
}

export const UserManagementPageSearchBar = ({
  userManagementListActiveView,
  userManagementListActiveRoleData,
  onRenderDataChange,
}: UserManagementPageSearchBarPropsTypes) => {
  const i18n = useI18N();
  const {
    userManagementSearchTerms,
    userManagementSearchQuery,
    onSearchTermsChange,
    onSearchQueryChange,
    findSearchedListForActiveView,
  } = useUserManagementPageSearchHook({
    userManagementListActiveView,
  });

  const searchTitle = () => {
    switch (userManagementListActiveView) {
      case UserManagementListActiveRoleEnum.SERVICE_USERS:
        return i18n("modules.search.technicalUsersApiTitle");
      case UserManagementListActiveRoleEnum.GATEWAY_SERVICE_USERS:
        return i18n("modules.search.technicalUsersGatewayTitle");
      default:
        return i18n("modules.search.usersTitle");
    }
  };

  const handleSearchResults = useCallback(
    (
      result: UserManagementListActiveRoleRenderDataType,
      meta: { isActive: boolean },
    ) => {
      onRenderDataChange(
        meta.isActive ? result : userManagementListActiveRoleData,
      );
    },
    [onRenderDataChange, userManagementListActiveRoleData],
  );

  return (
    <SearchBar
      data={userManagementListActiveRoleData}
      searchFn={findSearchedListForActiveView}
      emptyResult={[]}
      searchTerms={userManagementSearchTerms}
      searchQuery={userManagementSearchQuery}
      onSearchTermsChange={onSearchTermsChange}
      onSearchQueryChange={onSearchQueryChange}
      onSearchResults={handleSearchResults}
      texts={{ title: searchTitle() }}
    />
  );
};
